import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import config, { currentEnvironment } from 'services/config'

function initSentry() {
  if (currentEnvironment === 'Production') {
    Sentry.init({
      ignoreErrors: [
        'Non-Error promise rejection captured',
        'Registration failed - push service not available'
      ],
      dsn: config.sentryDsn,
      autoSessionTracking: true,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.3,
      release: `dash${process.env.REACT_APP_VERSION}`,
      normalizeDepth: 4,
      environment: `Production`
    })
  }
}

export default initSentry
